export const navLinks = [
  {
    label: 'Projects',
    pathname: '/',
    hash: '#project-1',
  },
  {
    label: 'About',
    pathname: '/',
    hash: '#about',
  }
  // {
  //   label: 'Contact',
  //   pathname: '/contact',
  // },
];

export const socialLinks = [
  {
    label: 'LinkedIn',
    url: 'https://www.linkedin.com/in/sharmanilay/',
    icon: 'linkedin',
  },
  {
    label: 'Github',
    url: 'https://github.com/sharmanilay',
    icon: 'github',
  },
  {
    label: 'Stack Overflow',
    url: 'https://stackoverflow.com/users/8064382/thenaamsake',
    icon: 'stackoverflow',
  },
  {
    label: 'Email',
    url: 'mailto:nilaysharma642@gmail.com',
    icon: 'email',
  },
  {
    label: 'Twitter',
    url: 'https://twitter.com/thenaamsake',
    icon: 'twitter',
  }
];
